/**
 * Парсит поля button_text и button_text_2 из объекта, игнорируя языковые суффиксы
 * @param {object} props - объект с полями вида { button_text, button_text_2, ... }
 * @returns {Array<{index: number, text: string}>} массив объектов с индексом и текстом кнопки
 */
export function parseButtonFields(props) {
  const buttonData = [];

  Object.entries(props).forEach(([key, value]) => {
    if (!value) return;

    // Обрабатываем button_text (индекс 0) и button_text_2 (индекс 1), игнорируя остальное
    const match = key.match(/^button_text(?:_(\d+))?$/);
    if (!match) return;

    const buttonIndex = match[1] ? parseInt(match[1], 10) - 1 : 0;
    buttonData[buttonIndex] = { index: buttonIndex, text: value };
  });

  return buttonData.filter(Boolean);
}
